import PendingList, { TPendingListRef } from '@/components/PendingList'
import { Button } from '@/components/ui/button'
import SecondaryPageLayout from '@/layouts/SecondaryPageLayout'
import { forwardRef, useRef, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useAtomValue } from 'jotai'
import { pendingIdsAtom } from '@/atoms/pending'

const PendingsPage = forwardRef(({ index }: { index?: number }, ref) => {
  const { t } = useTranslation()

  useEffect(() => {
    document.title = t('Pending | {{appName}}', { appName: window.hallway.universe.appName })
    history.replaceState(null, '')
  }, [])

  const listRef = useRef<TPendingListRef>(null)
  const [hasItems, setHasItems] = useState(false)
  const [isPublishingAll, setIsPublishingAll] = useState(false)
  const pendingIds = useAtomValue(pendingIdsAtom)

  useEffect(() => {
    if (listRef.current) {
      setHasItems(listRef.current.hasItems)
      setIsPublishingAll(listRef.current.isPublishingAll)
    }
  }, [pendingIds, listRef.current?.isPublishingAll, listRef.current?.hasItems])

  return (
    <SecondaryPageLayout
      ref={ref}
      index={index}
      title={t('Pending')}
      controls={
        hasItems ? (
          <Button
            size="sm"
            onClick={() => listRef.current?.publishAll()}
            disabled={isPublishingAll}
          >
            {isPublishingAll ? t('Publishing...') : t('Publish all')}
          </Button>
        ) : undefined
      }
      displayScrollToTopButton
    >
      <PendingList ref={listRef} />
    </SecondaryPageLayout>
  )
})

PendingsPage.displayName = 'PendingsPage'
export default PendingsPage
